/**
 * @export
 * @class Sticky
 * 탭 하단 Sticky
 *  - 옵션 자세히보기가 되지 않는 딜일 때 현재 보고있는 옵션만 보기 딜에 대한 정보를 제공
 */
export default class Sticky {
  constructor() {
    // 필요 data 유효 확인
    const {
      htStaticData: { bOptionDeal, bDetailviewAvailable, htDealInfo },
    } = TMON.oApp.htStorage;
    if (!bOptionDeal || bDetailviewAvailable || !htDealInfo.option) {
      return;
    }

    this.welWrapper = $('#_wrapSticky');

    this.isShowing = false;

    this.nHeaderHeight = TMON.util.gup('headerHeight')
      ? parseInt(TMON.util.gup('headerHeight'), 10)
      : $('header:first').outerHeight();

    this.render();
    this.setEvent();
    this.update();
  }

  render() {
    const {
      htStaticData: { htDealInfo },
    } = TMON.oApp.htStorage;

    const sHtml = `
            <div class="inner">
                <button type="button" class="close"><span class="blind">닫기</span></button>
                <p>${htDealInfo.option.optionTitle}</p>
            </div>
        `;

    this.welWrapper.html(sHtml);
  }

  setEvent() {
    this.welWrapper.on('click', '.close', this.hide);
  }

  clearEvent() {
    if (this.welWrapper) {
      this.welWrapper.off('click', '.close', this.hide);
    }
  }

  show = () => {
    this.isShowing = true;
    const STICKY_POS_TOP = 30;
    const welTabNavi = $('#tab-navigation ._fixedUIItem:first');

    const nStickyTopPos = welTabNavi.height();
    let nTop = STICKY_POS_TOP + this.nHeaderHeight + nStickyTopPos;

    if (TMON.oApp.sPlatform === 'PW') {
      // PC 일 경우 헤더 높이를 제외하고 계산한다.
      nTop = STICKY_POS_TOP + nStickyTopPos;
    }

    this.welWrapper.css({ top: nTop }).removeClass('close');
  };

  hide = () => {
    this.isShowing = false;
    this.welWrapper.addClass('close');
  };

  update() {
    // 필요 data 유효 확인
    const {
      htStaticData: { bOptionDeal, bDetailviewAvailable, htDealInfo },
    } = TMON.oApp.htStorage;
    if (!bOptionDeal || bDetailviewAvailable || !htDealInfo.option) return;

    const { tab, sticky } = TMON.oApp.htStorage;
    const bShow = tab === 'description' && sticky === 'tab-navigation';

    // 사용자 조작으로 layer가 닫혔을 때, 다시 trigger 될 때 제외하고 자동으로 상태 변경하지 않음
    if (bShow === this.isShowing) {
      return;
    }
    if (bShow && !this.isShowing) {
      this.show();
    } else {
      this.hide();
    }
  }
}
